import { render } from "./InstitutePayment.vue?vue&type=template&id=1e83c4ac&scoped=true"
import script from "./InstitutePayment.vue?vue&type=script&lang=js"
export * from "./InstitutePayment.vue?vue&type=script&lang=js"

import "./InstitutePayment.vue?vue&type=style&index=0&id=1e83c4ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e83c4ac"]])

export default __exports__